export const POSTCODE_PATTERN = new RegExp(
  "(^([Gg][Ii][Rr] ?0[Aa]{2})$)|(^((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) ?[0-9][A-Za-z]{2})$)"
);
